import { styled } from "@mui/system";

export const ModalContent = styled("div")({
    display: "flex",
    flexDirection: "column",
    gap: "32px"
  })
  
  export const ButtonContainer = styled("div")({
    display: "flex",
    alignSelf: "end",
    justifyContent: "end",
    alignItems: "center",
    gap: "8px"
  })
  
  export const CancelButton = styled("div")({
    cursor: "pointer",
    fontFamily: "DM Sans",
    fontSize: "16px",
    fontWeight: 500,
    color: "#495057"
  })